const schoolwork12: { app?: any} = window["schoolwork12"] = {};

schoolwork12.app = {
	pfEndPoint: tvAction.url.pfEndPoint,
    tvSchoolEndPoint: tvAction.url.tvSchoolEndPoint,
    tvEnrollmentEndPoint: tvAction.url.tvEnrollmentEndPoint,
    tvKmailEndPoint: tvAction.url.tvKmailEndPoint,
    endpoint: tvAction.url.endpoint,
    keycodeLoginEndPoint: '/wa/k12KeycodeLogin?keyCode=',
    pfkeycodeLoginEndPoint: '?keyCode=',
    primaryRolesArray: [1000, 1001, 1002, 1003, 1004, 1005, 1355, 1354, 1350],
    primaryRoles: {
        learningCoach: 1000,
        student: 1001,
        teacher: 1002,
        administrator: 1003,
        enrollmentAdvisor: 1004,
        tvSchoolAdmin: 1005,
        computerRuleManager: 1355,
        gradPlanManager: 1333,
        studentGradPlanEdit:1332,
        studentGradPlanView:1334,
        managementSchoolData: 1371, //TVSUITE-6538
        attendanceAdjuster: 1372,
        bulkAttendanceAdjuster: 1373,
        bulkEditAdditionalReq: 1374,
        bulkGradPlanImport: 1377,
        bulkSchoolDataRole: 1378,
        progParticipantMgr: 1103,
        tvAdministrationTools: 1354, //STT-9666:  User manages School Clusters in TV Action: Port existing TV Admin page
        dataManagement:1350,
        courseManagement: 1352,
        pathwayRequirements: 1382,
        bulkStudentCreationRole: 1379,
        pathwayRequirementEditRole: 1357
    },
    staffRoles:{
        counselor: 1160
    },
    bulkStatus:{
        pending:0,
        failPrevalidation:2
    },
    controller:  'appCtrl',
    errorMessages:{
        internalError:'Internal error occurred. Please reach out to system administrator.',
        noResultsFound:'No search results found.',
        sessionExpired:'Session expired. Please log back in.'
    }
};
